<template>
  <div class="bvip-info-container">
    
    <h2>购买即享 </h2>
    <p class="info">
      <span v-if="userInfo.sj !== 'Y'">专属资金以及</span>海量生活权益优惠。借款成功后，再分期支付权益订单。借款失败，不产生任何权益费用
    </p>
    <h3 v-if="userInfo.sj !== 'Y'">专属金融特权</h3>
    <div class="finance-equity" v-if="userInfo.sj !== 'Y'">
      <img src="./img_a@2x.png" />
      <img src="./img_b@2x.png" />
    </div>
    <template v-if="detail.allEquity && detail.allEquity.length">
      <h3>海量生活权益</h3>
      <div class="equity-list">
        <div
          class="item"
          v-for="(item, index) in detail.allEquity"
          :key="index"
        >
          <img
            :src="item.icon"
            class="icon"
          />
          <p class="name">{{ item.equityName }}</p>
          <span class="price">{{ item.equityDesc }}</span>
        </div>
      </div>
    </template>
    <p class="tips">- 权益由第三方提供兑换使用 -</p>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'BvipInfo',
  data () {
    return {
      detail: {}
    }
  },
  mounted () {
    this.info()
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('vip', ['queryBvipDetailX']),
    async info () {
      const { success, data } = await this.queryBvipDetailX({
        goodsCd: 'GPC_Q',
        oldMemberQuery: 'N'
      })
      if (success) {
        this.detail = data
        // this.detail.lifeEquityList = [...this.detail.lifeEquityList, ...this.detail.lifeEquityList, ...this.detail.lifeEquityList]
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.bvip-info-container {
  background: url(./img_v@2x.png) no-repeat #1c2032;
  background-size: 402px 333px;
  padding:50px 30px 30px;
  h2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: #ffd8bc;
    line-height: 59px;
  }
  p.info {
    font-family: PingFangSC, PingFang SC;
    padding: 15px 0 40px;
    font-weight: 400;
    font-size: 24px;
    color: #ffd8bc;
    line-height: 33px;
  }
  h3 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #ffd8bc;
    line-height: 40px;
  }
  .finance-equity {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 40px;
    img {
      width: 270px;
    }
  }
  .equity-list {
    display: flex;
    margin-top: 16px;
    padding: 35px 10px 0;
    align-items: center;
    background: #2d3041;
    border-radius: 20px;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: calc(100vh - 900px);
  }
  .icon {
    width: 80px;
    height: 80px;
    border-radius: 100%;
  }
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 25%;
    margin-bottom: 30px;
  }
  .name {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 37px;
    margin-top: 10px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-align: center;
  }
  .price {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffd8bc;
    text-align: center;
  }
  .line-through {
    text-decoration: line-through;
  }
  .tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #999999;
    line-height: 28px;
    text-align: center;
    margin-top: 38px;
  }
}
</style>
